/**
 * @generated SignedSource<<606c28fcd175bc867a7aaa497aac19d9>>
 * @relayHash fc0044ca8c91231525f44ce41746456e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 241a1dcf93c7b36a7676b80f2eaa65bbab15a3a29c13db3ed160b36b139ba841

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogAggAppDataQuery } from './BacklogAggAppDataQuery.graphql';

const node: PreloadableConcreteRequest<BacklogAggAppDataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "241a1dcf93c7b36a7676b80f2eaa65bbab15a3a29c13db3ed160b36b139ba841",
    "metadata": {},
    "name": "BacklogAggAppDataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
